import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import clockConfigClient, { ClockConfigValue } from "../../../api/clockConfig";

export const GLOBAL_QUERY_KEY = ["clock-config", "global"];
export const OVERRIDES_QUERY_KEY = ["clock-config", "overrides"];

/** Both lists move when either document changes — the effective values depend on both. */
const invalidateAll = (queryClient: ReturnType<typeof useQueryClient>) => {
  queryClient.invalidateQueries({ queryKey: GLOBAL_QUERY_KEY });
  queryClient.invalidateQueries({ queryKey: OVERRIDES_QUERY_KEY });
};

export const useClockGlobalConfig = () =>
  useQuery({
    queryKey: GLOBAL_QUERY_KEY,
    queryFn: () => clockConfigClient.getGlobal(),
  });

export const useClockConfigOverrides = () =>
  useQuery({
    queryKey: OVERRIDES_QUERY_KEY,
    queryFn: () => clockConfigClient.listOverrides(),
  });

export const useUpdateClockGlobalConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values: Record<string, ClockConfigValue>) =>
      clockConfigClient.updateGlobal(values),
    onSuccess: () => invalidateAll(queryClient),
  });
};

export const useUpdateClockConfigOverride = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      clockId,
      values,
    }: {
      clockId: string;
      values: Record<string, ClockConfigValue>;
    }) => clockConfigClient.updateOverride(clockId, values),
    onSuccess: () => invalidateAll(queryClient),
  });
};

export const useRemoveClockConfigOverride = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (clockId: string) => clockConfigClient.removeOverride(clockId),
    onSuccess: () => invalidateAll(queryClient),
  });
};
